import {spotheroPost} from 'api';
import {formatGetBlackoutsResponse} from 'api/blackouts/get-blackouts';
import {sendSentryException} from 'utils/error-handling';
import {BlackoutRequest, BlackoutResponse} from './blackouts.types';

interface CreateBlackoutsParams {
    facilityId: number;
    blackouts: BlackoutRequest[];
}

/**
 * Creates a collection of facility blackouts
 *
 * @param facilityId - The id of the facility to create the blackout for
 * @param blackouts - An array of blackouts to create
 *
 * @see '/api/v1/facilities/{facilityId}/blackouts/'
 */
const createBlackouts = async ({
    facilityId,
    blackouts,
}: CreateBlackoutsParams) => {
    try {
        const response = await spotheroPost<BlackoutResponse[]>(
            `facilities/${facilityId}/blackouts/`,
            {
                blackouts,
            },
            null,
            false
        );

        const formattedResponse = formatGetBlackoutsResponse(response);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default createBlackouts;
